import React from 'react';
import type { FC } from 'react';
import { match } from 'variant';
import { Box, Text } from '@wix/cli-ui-kit';
import { Trans } from '@wix/cli-i18n';
import type { TemplateSource } from '../parse-command-options.js';

interface StartFromTemplateMessageProps {
  template: TemplateSource;
}

export const StartFromTemplateMessage: FC<StartFromTemplateMessageProps> = ({
  template,
}) => {
  const messageComponent = match(template, {
    App: ({ payload }) => (
      <Trans
        i18nKey="create_app.template_is_set_from_options.template_id"
        values={{
          templateName: payload.title,
        }}
        components={[<Text bold />]}
      />
    ),
    GitRepo: ({ url }) => (
      <Trans
        i18nKey="create_app.template_is_set_from_options.git_repository"
        values={{
          templateRepoUrl: url,
        }}
        components={[<Text bold />]}
      />
    ),
    Local: ({ path }) => (
      <Trans
        i18nKey="create_app.template_is_set_from_options.local"
        values={{
          templatePath: path,
        }}
        components={[<Text bold />]}
      />
    ),
    Default: () => null,
  });

  return <Box marginBottom={1}>{messageComponent}</Box>;
};
